module.exports = __webpack_public_path__ + "static/media/horizontal-window.f737c5c1.png";